import * as React from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';


interface MessageDialogProps {
  isOpen: boolean
  title: string;
  default?: string;
  hideMessage?: boolean;
  onClose: () => void;
  onSend: (message: string) => void;
}

export const MessageDialog: React.FC<MessageDialogProps> = (props) => {

  const [message, setMessage] = React.useState(props.default || '');

  return (
    <Dialog open={props.isOpen} onClose={props.onClose} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">{props.title}</DialogTitle>
      {
        props.hideMessage ? null : (
          <DialogContent>
            <DialogContentText>
              Send a message to the Artist:
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label="Message"
              value={message}
              onChange={(ev) => setMessage(ev.target.value)}
              type="text"
              fullWidth
              multiline
              rows={8}
            />
          </DialogContent>
        )
      }
      <DialogActions>
        <Button onClick={props.onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={() => props.onSend(message)} color="default">
          Send
        </Button>
      </DialogActions>
    </Dialog>
  )
}